import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { keysToCamel } from './utils/case.util';

@Injectable({ providedIn: 'root' })
export class ApiService {
  // Use configured API base if provided (production builds will use environment.prod)
  private base = environment?.API_BASE_URL?.replace(/\/$/, '') ?? '/api/v1';

  constructor(private http: HttpClient) {}

  get<T>(path: string, params?: Record<string, any>): Observable<T> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(k => {
        if (params[k] !== undefined && params[k] !== null) httpParams = httpParams.set(k, params[k]);
      });
    }
    const url = `${this.base}${path}`;
    console.log('[ApiService] GET:', url, { params: httpParams });
    return this.http.get<T>(url, { params: httpParams }).pipe(map(res => keysToCamel(res)));
  }

  post<T>(path: string, body: any): Observable<T> {
    const url = `${this.base}${path}`;
    console.log('[ApiService] POST:', url, body);
    return this.http.post<T>(url, body).pipe(map(res => keysToCamel(res)));
  }

  put<T>(path: string, body: any): Observable<T> {
    const url = `${this.base}${path}`;
    console.log('[ApiService] PUT:', url, body);
    return this.http.put<T>(url, body).pipe(map(res => keysToCamel(res)));
  }

  patch<T>(path: string, body: any): Observable<T> {
    const url = `${this.base}${path}`;
    console.log('[ApiService] PATCH:', url, body);
    return this.http.patch<T>(url, body).pipe(map(res => keysToCamel(res)));
  }

  delete<T>(path: string): Observable<T> {
    const url = `${this.base}${path}`;
    console.log('[ApiService] DELETE:', url);
    return this.http.delete<T>(url).pipe(map(res => keysToCamel(res)));
  }
}